<template>
  <div class="common-modal">
    <div class="bg"></div>
    <button class="close" @click="hideAppStoreLightVersionModal">&nbsp;</button>
    <div class="modal-body">
      <h3>{{ this.$t('app_store_light_version') }}</h3>
      <div class="notice" v-html="this.installationNotice"></div>
      <div class="logo">
        <img :src="this.$iosAppStoreIconUrl" alt="logo" />
      </div>
      <div>{{ this.$iosAppStoreName }}</div>
      <div class="btn btn-group">
        <a href="javascript:;" class="btn" v-on:click="copyKey()"><div>{{ this.$t("copy_key") }}</div></a>
        <a :href="this.$iosAppStoreUrl" target="_blank" class="btn"><div>{{ this.$t("get") }}</div></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppStoreLightVersionModal",
  props: ["channel", "platform", "title", "showQrcode", "invitationCode"],
  data: function() {
    return {};
  },
  computed: {
    installationNotice: function() {
        return this.$t(`appstore_installation_notice`)
    }
  },
  methods: {
    hideAppStoreLightVersionModal: function() {
      this.$emit("hideAppStoreLightVersionModal");
    },
    copyKey: function() {
      let textArea = document.createElement("textarea");
      textArea.value = this.$iosAppStoreData;
      textArea.style.width = "1px";
      textArea.style.height = "1px";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        document.body.removeChild(textArea);
      } catch (err) {
        console.log("Oops, unable to copy");
      }
      this.$toast.success(this.$t("copy_complete"), { position: "top"});
    }
  },
  created: function() {},
};
</script>

<style lang="scss">
@import "../assets/style.scss";
.common-modal {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  place-items: center;
  .bg {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.9);
    position: fixed;
  }
  .modal-body {
    max-width: 500px;
    z-index: 10;
    width: 100%;
    .notice {
      text-align: left;
      padding: 1rem 1rem;
      line-height: 1.4rem;
      width: 100%;
    }
    .logo {
      padding-top: 1rem;
      img { max-width: 80px; height: auto; border-radius: 10px;}
    }
    .btn-group {
      display: flex;
      justify-content: center;
      margin-top: 1.2rem;
      .btn.disabled { .label { color: #66094a; } }
      .btn {
        display: flex;
        border-radius:0.15em;
        background: #cc1c71;
        box-shadow:inset 0 -0.6em 0 -0.35em rgba(0,0,0,0.30);
        padding: 0.8rem 1.6rem;
        margin-right: 1rem;
        cursor: pointer;
        text-decoration: none;
        position:relative;
        color: #fff;
        &:hover {
          top: -0.1em;
          background: #dd2980;
          box-shadow:inset 0 -0.6em 0 -0.35em rgba(0,0,0,0.30);
        }
        &:active {
          top: 0.1em;
          background: #bd1a69;
          box-shadow:inset 0 -0.6em 0 -0.35em rgba(0,0,0,0.30);
        }
        &:last-child {
          margin-right: 0;
        }
        span { font-size: 1rem; color: #eee; }
        .icon img {
          width: 30px;
          height: auto;
        }
        .label {
          line-height: 2rem;
          font-size: 1.2rem;
          color: #f2f2f2;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
